// extracted by mini-css-extract-plugin
export default {"landingContainer":"landing-page__landingContainer__DVZ7G","sideNavContainer":"landing-page__sideNavContainer__u7_aN"};